"use client";

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from "@tanstack/react-query";
import { filterQueryOptions } from "../lib/react-query";
import { useClient } from "../utils/client/client";
import { useLocale } from "./use-locale";

/**
 * Fetches and provides filter information based on the current locale and subclient.
 * Uses TanStack Query for data fetching with infinite cache duration.
 */
export const useFilterOptions = () => {
  const $ = _c(3);
  const locale = useLocale();
  const client = useClient();
  let t0;
  if ($[0] !== client || $[1] !== locale) {
    t0 = filterQueryOptions.info(locale, client);
    $[0] = client;
    $[1] = locale;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data
  } = useSuspenseQuery(t0);
  return data;
};